import "./topbar.scss";
import { Person, Mail, GitHub, LinkedIn, Brightness4, Brightness7 } from "@mui/icons-material";
import { CONTACT_PHONE, CONTACT_EMAIL } from "../../config";

export default function Topbar({ menuOpen, setMenuOpen, darkMode, setDarkMode }) {
  return (
    <div className={"topbar " + (menuOpen ? "active" : "")}>
      <div className="wrapper">
        <div className="left">
          <a href="#intro" className="logo">
            <span className="logoFull">Parth Padhiyar</span>
            <span className="logoShort">Parth</span>
          </a>
          <div className="itemContainer">
            <Person className="icon" />
            <span>{CONTACT_PHONE}</span>
          </div>
          <div className="itemContainer">
            <Mail className="icon" />
            <span>{CONTACT_EMAIL}</span>
          </div>
        </div>
        <div className="right">
          <div className="socials">
            <a
              href="https://github.com/ppadhiyar"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="GitHub"
            >
              <GitHub className="icon" />
            </a>
            <a
              href="https://linkedin.com/in/parth-padhiyar"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <LinkedIn className="icon" />
            </a>
          </div>
          <button
            className="themeToggle"
            onClick={() => setDarkMode(!darkMode)}
            aria-label="Toggle dark mode"
          >
            {darkMode ? (
              <Brightness7 className="toggleIcon" />
            ) : (
              <Brightness4 className="toggleIcon" />
            )}
          </button>
          <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            <span className="line1"></span>
            <span className="line2"></span>
            <span className="line3"></span>
          </div>
        </div>
      </div>
    </div>
  );
}
